export enum EEventSourceCommand {
  COUNTERS = 'COUNTERS',
  EXPUNGE = 'EXPUNGE',
  EXISTS = 'EXISTS',
  FETCH = 'FETCH',
  WEB_AUTHN_AUTHENTICATOR_REMOVED = 'WebAuthnAuthenticatorRemoved',
  WEB_AUTHN_AUTHENTICATOR_ADDED = 'WebAuthnAuthenticatorAdded',
  APPLICATION_PASSWORD_ADDED = 'ApplicationPasswordAdded',
  APPLICATION_PASSWORD_REMOVED = 'ApplicationPasswordRemoved',
  MCP_TOKEN_CREATED = 'McpTokenCreated',
  MCP_TOKENS_DELETED = 'McpTokensDeleted',
  DETAILS_UPDATED = 'DetailsUpdated',
  ATTRIBUTES_UPDATED = 'AttributesUpdated',
  AVATAR_UPLOADED = 'AvatarUploaded',
  AVATAR_REMOVED = 'AvatarRemoved',
  LOG_OUT_DEVICE_USER = 'LogOutDeviceUser',
  LOG_OUT_DEVICE = 'LogOutDevice',
  LOG_OUT_USER = 'LogOutUser',
  ADDRESSBOOK_UPDATED = 'AddressbookUpdated',
  ADDRESSBOOK_DELETED = 'AddressbookDeleted',
  CONTACT_UPDATED = 'ContactUpdated',
  CONTACT_USED_AT_UPDATED = 'ContactUsedAtUpdated',
  CONTACT_DELETED = 'ContactDeleted',
  CONTACTS_IMPORTED = 'ContactsImported',
  GROUP_UPDATED = 'GroupUpdated',
  GROUP_DELETED = 'GroupDeleted',
  SIGNATURE_UPDATED = 'SignatureUpdated',
  SIGNATURE_DELETED = 'SignatureDeleted',
  FOLDER_RENAMED = 'RENAME',
  FOLDER_CREATE = 'CREATE',
  FOLDER_DELETE = 'DELETE',
  FOLDER_ORDER = 'FolderOrder',
  FOLDERS_ORDER_UPDATED = 'FoldersOrderUpdated',
  FOLDER_UPDATED = 'FolderUpdated',
  WHITELIST_EMAIL_UPDATED = 'WhitelistEmailUpdated',
  WHITELIST_EMAIL_DELETED = 'WhitelistEmailDeleted',
  FILTER_UPDATED = 'FilterUpdated',
  FILTER_MOVE_TO_BOTTOM = 'FilterMoveToBottom',
  FILTER_DELETED = 'FilterDeleted',
  FILTER_CREATED = 'FilterCreated',
  FILTER_IMPORTED = 'FilterImported',
  FILTER_IMPORT_FAILED = 'FilterImportFailed',
  FILTER_IMPORT_SUCCESS = 'FilterImportSuccess',
  FILTER_IMPORT_SKIPPED = 'FilterImportSkipped',
  RECENT_SEARCH_UPDATED = 'RecentSearchUpdated',
  RECENT_SEARCH_DELETED = 'RecentSearchDeleted',
  REMOTE_CONTENT_WHITELIST = 'RemoteContentWhitelist',
  UPGRADE_REQUEST_RESET = 'UpgradeRequestReset'
}
